import { PromoCycleModalForm } from "./PromoCycleModalForm"

const PromoCycleModalFormWrapper = ({
  setOpenPromoCycleModal,
  setPromoCycleId,
  promoCycleId,
  getBookings
}) => {
  const itemIdForUpdate = null;
  const isLoading = false;

  if (promoCycleId) {
    return (
      <PromoCycleModalForm
        setOpenPromoCycleModal={setOpenPromoCycleModal}
        setPromoCycleId={setPromoCycleId}
        promoCycleId={promoCycleId}
        itemIdForUpdate={itemIdForUpdate}
        isLoading={isLoading}
        getBookings={getBookings}
      />
    );
  }
  return null;
};

export { PromoCycleModalFormWrapper };
